<template> 

  <div style="width:100%">
      <div style="width:100%;height:auto;margin:0;background-color:white;border:1px solid #ddd;border-top:none;border-right:none;border-bottom:none;padding:5px;" v-for="item in keysListMealDate" :key="item">  
        <a-row>
          <div style="width:100%;display: flex;margin:0;border:1px solid #ddd">
            <div style="width:90%;margin:10px;margin-bottom:0;padding:10px;border:1px solid #dddddd;padding-bottom:0;margin-bottom:0">
              <div style="width:100%;">
                  <div style="border:1px solid #dddddd;margin:0;font-size: 14px;line-height:28px;">Meal Start</div>
                  <a-form-item style="border:1px solid #dddddd;border-top:none;border-bottom:none;padding:10px;margin-bottom:0">
                      <a-date-picker style="width:100%;" placeholder=""
                          :showToday="false"
                          valueFormat="YYYY-MM-DD"
                          v-decorator="[
                              `${title}Mealstart${id}[${item}]`,
                              {
                                  initialValue: arr !== undefined && arr.mealdate !== undefined && arr.mealdate[item] !== undefined && arr.mealdate[item].mealstart ? arr.mealdate[item].mealstart.toString().split('T')[0] : null,
                                  rules: [{ required: false, message: 'mealstart !' }]
                              }
                          ]"
                          >
                      </a-date-picker>
                  </a-form-item>
              </div>
              <div style="width:100%;">
                  <div style="border:1px solid #dddddd;font-size: 14px;line-height:28px;">Meal End</div>
                  <a-form-item style="border:1px solid #dddddd;border-top:none;padding:10px">
                      <a-date-picker style="width:100%;" placeholder=""
                          :showToday="false"
                          valueFormat="YYYY-MM-DD"
                          v-decorator="[
                              `${title}Mealend${id}[${item}]`,
                              {
                                initialValue: arr !== undefined && arr.mealdate !== undefined && arr.mealdate[item] !== undefined && arr.mealdate[item].mealend ? arr.mealdate[item].mealend.toString().split('T')[0] : null,
                                  rules: [{ required: false, message: 'mealend !' }]
                              }
                          ]"
                          >
                      </a-date-picker>
                  </a-form-item>
              </div>
            </div>
            <div style="margin-top:auto;margin-bottom:auto;width:15%">
                <a-button shape="circle" type="dashed" icon="minus" @click="removeRowMealDate(item)" class="minusRowBtn" :size="'small'"></a-button>
            </div>
          </div>
        </a-row>
      </div> 
      <div style="display:flex;margin-bottom:10px;margin-right:3px">
          <a-button style="margin-left:auto;margin-right:0;margin-top:5px" :style="{ background: '#0071a1',border:'none'}" @click="addRowMealDate" type="primary" :size="'small'">
              Add Row
          </a-button>
      </div>
  </div>   
</template>
<script>
import moment from 'moment';
export default {
  name: 'DynamicForm',
  props: {
    title: {
      type: String,
      default: ''
    },
    id: {
      type: Number, 
    },
    arr: {
      type: Object,
      default: function () {
        return {}
      }
    },
  },
  components: {
      
  },
  data () {
    return {
      idMealDate: 0,
      keysListMealDate: [],
      
      dateFormat : (val) => {
        return moment(val).utc().format('YYYY-MM-DD')// HH:mm:ss')
      }
    }
  },
  created () {
    // this.form = this.$form.createForm(this)
    this.init()
  },
  methods: {
    moment,
    init () {
      const arr = []
      if (this.arr.mealdate != undefined && this.arr.mealdate.length != 0) {
        this.idMealDate = 0;
        for (let i = 0; i < (this.arr.mealdate).length; i++) {
          arr.push(i)
          this.idMealDate = this.idMealDate + 1
        }
        this.keysListMealDate = arr
      }
      else{
        this.keysListMealDate = [0]
      }
    },

    removeRowMealDate (k) {
      if (this.keysListMealDate.length === 0) {
        return
      }
      this.keysListMealDate = this.keysListMealDate.filter(item => item !== k)
    },
    addRowMealDate () {
      if(this.keysListMealDate.length === 1 && this.idMealDate === 0){
        this.keysListMealDate = this.keysListMealDate.concat(1)
        this.idMealDate = 2
      }else{
        this.keysListMealDate = this.keysListMealDate.concat(this.idMealDate)
        this.idMealDate = this.idMealDate + 1
      }
    },
  }
}
</script>